module.exports = __webpack_public_path__ + "img/c7.260fad7f.png";